import React from 'react';

import { translate } from '../../../base/i18n';
import { Icon, IconNetworkLost } from '../../../base/icons';
import { MHParticipantConnectionStatus } from '../../../base/lib-meet-hour';
import { LAYOUTS } from '../../../video-layout';

/**
 * Renders the connection lost overlay for remote participants.
 *
 * @returns {ReactElement|null}
 */
function ConnectionLostOverlay({ _participant, filmStripView, t }) {
    if (!_participant) {
        return null;
    }

    const { connectionStatus } = _participant;

    if (connectionStatus !== MHParticipantConnectionStatus.INACTIVE
        && connectionStatus !== MHParticipantConnectionStatus.INTERRUPTED) {
        return null;
    }

    const style = filmStripView === LAYOUTS.TILE_VIEW ? {
        zIndex: 999
    } : { zIndex: 1003 };

    //     z-index: 1002;
    // top: unset;
    // left: unset;
    // right: unset;
    // cursor: unset;
    // margin: 0 0px 10px 10px;
    // width: stretch;
    // height: 98.5%;

    return (
        <div
            className = { filmStripView === LAYOUTS.TILE_VIEW ? 'videocontainer__connectionLostOverlay' : 'videocontainer__connectionLostOverlay-vertical' }
            style = { style }>
            <div className = 'connection-lost-icon'>
                <Icon src = { IconNetworkLost } />
            </div>
            <div className = 'connection-lost-text'>
                {t('videothumbnail.connectionLost')}<span className = 'dots'><span>.</span><span>.</span><span>.</span></span>
            </div>
        </div>
    );
}

export default translate(ConnectionLostOverlay);
